import {
  SYSColumnDef,
  SYSTableDef,
} from "../../../../../_ovlclient/src/library/table/tableapi"
export type UserAdministration_PermissionType = {
  RoleCode?: string
  Permission?: string
  HasPermission?: boolean
  PermissionDesc?: string
  Read?: boolean
  Modify?: boolean
  Add?: boolean
  Delete?: boolean
}

let columns: {
  [key in keyof UserAdministration_PermissionType]: SYSColumnDef
} = {
  Permission: {
    ui: {
      noLabel: true,
      visibility: "Table",
    },
    sortable: true,
  },

  PermissionDesc: {
    ui: {
      labelTranslationKey: "SYSUserAdministrationPermissionColDesc",
      readonly: true,
    },
    sortable: true,
    schema: { isCalculatedColumn: true },
  },

  HasPermission: {
    filter: { columnFilter: { type: "none" } },
    ui: {
      labelTranslationKey: "SYSUserAdministrationPermissionColHasPermission",
    },
    sortable: true,
    control: "checkbox",
  },

  Read: {
    filter: { columnFilter: { type: "none" } },
    groups: { group: 1 },
    ui: {
      labelTranslationKey: "SYSUserAdministrationPermissionColRead",
    },
    control: "checkbox",
  },
  Modify: {
    filter: { columnFilter: { type: "none" } },
    groups: { group: 1 },
    ui: {
      labelTranslationKey: "SYSUserAdministrationPermissionColModify",
    },
    control: "checkbox",
  },
  Add: {
    filter: { columnFilter: { type: "none" } },
    groups: { group: 1 },
    ui: {
      labelTranslationKey: "SYSUserAdministrationPermissionColAdd",
    },
    control: "checkbox",
  },
  Delete: {
    filter: { columnFilter: { type: "none" } },
    groups: { group: 1 },
    ui: {
      labelTranslationKey: "SYSUserAdministrationPermissionColDelete",
    },
    control: "checkbox",
  },
}

export let tblUserAdministration_Permission: SYSTableDef = {
  id: "SYSUserAdministration_Permission",
  feature: "SYSUserAdministration",
  permission: "SYSRA",
  database: {
    dataIdField: "Permission",
    dbInsertMode: "Manual",
  },
  server: {
    endpoint: "userpermission",
  },
  features: {
    headerMenu: true,
    focusToFirstEditableField: true,
    edit: true,
  },
  options: {
    filterSortSettings: { enablePersist: false },
    initial_sort: { field: "Permission", direction: "asc" },
    rendering: {
      groups: {
        1: {
          className: "editgroup_modifiers",
          translationKey: "SYSUserAdministrationPermissionEditGroupModifiers",
        },
      },
      controls: { fillSpaceIfNotVisible: false },
    },
  },

  columns,
}
let resultingPermission: SYSTableDef = JSON.parse(
  JSON.stringify(tblUserAdministration_Permission)
)
resultingPermission.features.add = false
resultingPermission.features.edit = false
resultingPermission.features.delete = false

export let tblUserAdministration_ResultingPermission: SYSTableDef =
  resultingPermission
